import { render } from "./FlashCoursewareCard.vue?vue&type=template&id=4dfda148&scoped=true"
import script from "./FlashCoursewareCard.vue?vue&type=script&lang=ts"
export * from "./FlashCoursewareCard.vue?vue&type=script&lang=ts"

import "./FlashCoursewareCard.vue?vue&type=style&index=0&id=4dfda148&scoped=true&lang=css"
import "./FlashCoursewareCard.vue?vue&type=style&index=1&id=4dfda148&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4dfda148"

export default script